import { defineMessages } from 'react-intl';

export const scope = 'app.components.CalibrationAssignmentsPoller';

export const messages = defineMessages({
  pendingPrompt: {
    id: `${scope}.pendingPrompt`,
    defaultMessage: 'You have {count} pending calibration {assignment}',
  },
  btnView: {
    id: `${scope}.btnView`,
    defaultMessage: 'View',
  },
  btnLater: {
    id: `${scope}.btnLater`,
    defaultMessage: 'Later',
  },
});
